class VwHbsOrderIlacuygulamaDTO {
    id: number = 0;
    adi?: string = "";
    durum?: number = null;
    drplansaat?: string = "";
    dozmiktar?: number = null;
    uygulayanAdi?: string = "";
    uygKullaniciId?: number = null;
    uygTarihsaat?: string = null;
    uygDozmiktar?: number = null;
    uygAciklama?: string = "";
    uygIptaltarih?: string = null;
    uygIptalkullaniciId?: number = null;
    uygIptalNedenId?: number = null;
    orderIlacId?: number = null;
    draciklama?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptalKullanici?: number = null;
    iptalTarihi?: string = null;
    fkIptalneden?: number = null;
    uygDurumu?: number = 1;
    islem?: string = "";
    orderMiktar?: number = null;
    aciklama?: string = "";
    talepYeri?: string = "";
    acil?: string = "";
    iptalNedeni?: string = "";
    redDoktorAdi?: string = "";
    kayitTarih?: string = null;
    kullanimSekli?: string = "";
    secimTuru?: number = null;
    plantarih?: string = null;
    muracaatId?: number = null;
    tip?: number = 1; //1 ise uygulama | 2 ise uygulama iptal
};
export default VwHbsOrderIlacuygulamaDTO;